import { render, staticRenderFns } from "./BDelete.vue?vue&type=template&id=4077988c&scoped=true"
import script from "./BDelete.vue?vue&type=script&lang=js"
export * from "./BDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4077988c",
  null
  
)

export default component.exports